export default "__VITE_ASSET__BEOojOB1__"